<template>
  <b-modal :id="modalId" size="lg" scrollable modal-class="db-modal" @show="showModal" @hidden="hiddenModal">
    <template #modal-header>
      <div class="db-modal-head">
        <h2 class="db-modal-title">{{ popUpData ? "Editar aviso" : "Nuevo aviso" }}</h2>
        <p class="db-modal-subtitle">Se mostrará como ventana emergente al entrar en la web los días indicados.</p>
      </div>
      <button type="button" class="db-icon-btn" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <div class="ep-layout">
      <div class="db-form">
        <div class="db-field">
          <label class="db-label" for="ep-titulo">Título</label>
          <input id="ep-titulo" v-model.trim="titlePopUp" type="text" class="db-input" placeholder="Ej.: Horario de Navidad" />
          <p class="db-hint">Uso interno: no se muestra en la web.</p>
        </div>

        <div class="db-field">
          <label class="db-label" for="ep-url">Enlace (opcional)</label>
          <input id="ep-url" v-model.trim="urlEnlace" type="url" class="db-input" placeholder="https://…" />
          <p class="db-hint">Si lo rellenas, al pulsar la imagen se abrirá este enlace.</p>
        </div>

        <div class="db-field">
          <span class="db-label">
            Días en los que aparece
            <span class="db-badge">{{ fechas.length }}</span>
          </span>

          <div class="db-segmented ep-modo" role="group" aria-label="Forma de añadir fechas">
            <button type="button" :class="{ 'is-active': modo === 'dia' }" @click="modo = 'dia'">Un día</button>
            <button type="button" :class="{ 'is-active': modo === 'rango' }" @click="modo = 'rango'">Varios días seguidos</button>
          </div>

          <div class="ep-add">
            <input v-model="desde" type="date" class="db-input" :aria-label="modo === 'rango' ? 'Desde' : 'Fecha'" />
            <template v-if="modo === 'rango'">
              <span class="ep-add-sep">a</span>
              <input v-model="hasta" type="date" class="db-input" :min="desde" aria-label="Hasta" />
            </template>
            <button type="button" class="db-btn db-btn--ghost" :disabled="!puedeAnadir" @click="anadirFechas">
              <span class="material-symbols-outlined">add</span> Añadir
            </button>
          </div>

          <div v-if="fechas.length" class="ep-chips">
            <span v-for="f in fechasOrdenadas" :key="f" class="ep-chip" :class="{ 'is-past': f < hoy }">
              {{ formatFecha(f) }}
              <button type="button" :aria-label="'Quitar ' + formatFecha(f)" @click="quitarFecha(f)">
                <span class="material-symbols-outlined">close</span>
              </button>
            </span>
            <button v-if="hayPasadas" type="button" class="db-btn db-btn--ghost db-btn--sm" @click="quitarPasadas">
              Quitar fechas pasadas
            </button>
          </div>
          <p v-else class="db-hint">Todavía no has añadido ningún día.</p>
        </div>
      </div>

      <div class="db-field">
        <span class="db-label">Imagen</span>
        <button
          type="button"
          class="db-image-pick ep-image"
          :class="{ 'has-image': imagenPopUpSrc }"
          @click="$bvModal.show('imagenPopUp')"
        >
          <template v-if="imagenPopUpSrc">
            <img :src="base + '/img/gallery/' + imagenPopUpSrc" :alt="titlePopUp" />
            <span class="db-image-pick-overlay">
              <span class="material-symbols-outlined">swap_horiz</span> Cambiar
            </span>
          </template>
          <span v-else class="db-image-pick-empty">
            <span class="material-symbols-outlined">add_photo_alternate</span>
            Elegir imagen
          </span>
        </button>
      </div>
    </div>

    <selectorImagenes id="imagenPopUp" @imagen="imagenPopUp" />

    <template #modal-footer>
      <p v-if="faltan.length" class="db-hint">Falta: {{ faltan.join(", ") }}.</p>
      <span class="db-toolbar-spacer"></span>
      <button type="button" class="db-btn db-btn--ghost" @click="closeModal">Cancelar</button>
      <button type="button" class="db-btn" :disabled="faltan.length > 0 || guardando" @click="savePopup">
        <span v-if="guardando" class="db-spinner"></span>
        {{ popUpData ? "Guardar cambios" : "Crear aviso" }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import axios from "@/directives/axios.js";
import selectorImagenes from "./SelectorImages.vue";
import {
  avisar,
  formatFecha,
  toISODate,
  parseFecha,
  avisarError,
} from "@/directives/dbDialogs.js";

const MAX_DIAS_RANGO = 366;

export default {
  name: "editorPopUp",

  components: {
    selectorImagenes,
  },
  props: ["modalId", "popUpData"],
  data() {
    return {
      modo: "dia",
      desde: "",
      hasta: "",
      fechas: [],
      imagenPopUpSrc: "",
      titlePopUp: "",
      urlEnlace: "",
      guardando: false,
      hoy: toISODate(new Date()),
      base: this.$media,
    };
  },
  computed: {
    fechasOrdenadas() {
      return [...this.fechas].sort();
    },
    hayPasadas() {
      return this.fechas.some((f) => f < this.hoy);
    },
    puedeAnadir() {
      if (!this.desde) return false;
      return this.modo === "dia" || (this.hasta && this.hasta >= this.desde);
    },
    faltan() {
      const f = [];
      if (!this.titlePopUp) f.push("título");
      if (!this.imagenPopUpSrc) f.push("imagen");
      if (!this.fechas.length) f.push("al menos un día");
      return f;
    },
  },
  methods: {
    formatFecha,
    showModal() {
      this.hoy = toISODate(new Date());
      if (this.popUpData) {
        this.imagenPopUpSrc = this.popUpData.imagen || "";
        this.titlePopUp = this.popUpData.titulo || "";
        this.urlEnlace = this.popUpData.url || "";
        this.fechas = [...new Set((this.popUpData.fechas || "").split(",").map((f) => f.trim()).filter(Boolean))];
      }
      this.$store.dispatch("changeAllImages");
    },
    hiddenModal() {
      this.modo = "dia";
      this.desde = "";
      this.hasta = "";
      this.imagenPopUpSrc = "";
      this.titlePopUp = "";
      this.urlEnlace = "";
      this.fechas = [];
      this.guardando = false;
    },
    anadirFechas() {
      const nuevas = [];
      if (this.modo === "dia") {
        nuevas.push(this.desde);
      } else {
        let d = parseFecha(this.desde);
        const fin = parseFecha(this.hasta);
        for (let i = 0; d <= fin && i < MAX_DIAS_RANGO; i++) {
          nuevas.push(toISODate(d));
          d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        }
      }
      this.fechas = [...new Set([...this.fechas, ...nuevas])];
      this.desde = "";
      this.hasta = "";
    },
    quitarFecha(fecha) {
      this.fechas = this.fechas.filter((f) => f !== fecha);
    },
    quitarPasadas() {
      this.fechas = this.fechas.filter((f) => f >= this.hoy);
    },
    imagenPopUp(value) {
      this.imagenPopUpSrc = value && value.length ? value[0].imagen : "";
    },
    async savePopup() {
      if (this.faltan.length) return;
      this.guardando = true;
      const data = {
        titulo: this.titlePopUp,
        imagen: this.imagenPopUpSrc,
        fechas: this.fechasOrdenadas.toString(),
        url: this.urlEnlace,
      };
      if (this.popUpData) data.id = this.popUpData.id;

      try {
        const { data: resp } = await axios.post(this.popUpData ? "/popup/editarPopUp" : "/popup/nuevoPopUp", data);
        avisar(this, `«${this.titlePopUp}» se mostrará ${this.fechas.length === 1 ? "1 día" : this.fechas.length + " días"}.`, "success", this.popUpData ? "Aviso modificado" : "Aviso creado");
        this.$emit("actualizaLista", resp.todosPopUp);
        this.closeModal();
      } catch (error) {
        avisarError(this, error, "No se pudo guardar el aviso.");
      } finally {
        this.guardando = false;
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.ep-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

@media (max-width: 760px) {
  .ep-layout {
    grid-template-columns: 1fr;
  }
}

.ep-image {
  aspect-ratio: 3 / 4;
}

.ep-image img {
  object-fit: contain;
  background: var(--sd-surface-2);
}

.ep-modo {
  align-self: flex-start;
}

.ep-add {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.ep-add .db-input {
  flex: 1;
  min-width: 140px;
}

.ep-add-sep {
  font-size: 0.85rem;
  color: var(--sd-muted);
}

.ep-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.ep-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 30px;
  padding: 0 4px 0 10px;
  border-radius: 999px;
  background: var(--sd-primary-soft);
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--sd-primary);
}

.ep-chip.is-past {
  background: var(--sd-surface-2);
  color: var(--sd-muted);
  text-decoration: line-through;
}

.ep-chip button {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.ep-chip button:hover {
  background: rgba(0, 0, 0, 0.08);
}

.ep-chip .material-symbols-outlined {
  font-size: 15px;
}
</style>
